<template>
  <footer class="footer d-none d-md-block" style="background: #1A191D !important;">
    <div class="container-fluid d-flex justify-content-between" id="footer">
      <div class="footer-info">
        <img alt="logo" class="img-fluid mb-4" width="150px" src="../assets/images/home/logo.png">
        <div class="footer-title">
          About us
        </div>
        <div class="footer-text mb-4">
          Global Vision Group is present everywhere! <br>
          where technology, education, art and business
          impact everyday life.
        </div>
        <div class="footer-title">
          Contact us
        </div>
        <div class="footer-text">
          +971 2 658 2627 <br>
          info@gvc.ae <br>
          UAE - Abu Dhabi - Khaldiya - Al Ahliya Tower
        </div>
      </div>
      <div class="footer-nav">
        <div class="footer-title mb-4">
          Navigation
        </div>
        <ul class="footer-navigation">
          <li class="footer-text"><a href="#">GV Group</a></li>
          <li class="footer-text"><a href="#">GV Learning</a></li>
          <li class="footer-text"><a href="#">Global Vision Store</a></li>
          <li class="footer-text"><a href="#">GV Business</a></li>
          <li class="footer-text"><a href="#">Let’s Talk</a></li>
        </ul>
      </div>
      <div class="footer-links">
        <div class="footer-title mb-4">
          Helpful links
        </div>
        <ul class="footer-navigation">
          <li class="footer-text"><a href="#">Global Vision Training and Education
            Consultancy</a></li>
          <li class="footer-text"><a href="#">Global Vision Events Management</a></li>
          <li class="footer-text"><a href="#">GVTRONICS</a></li>
          <li class="footer-text"><a href="#">Portfolio</a></li>
          <li class="footer-text"><a href="#">Hire Us</a></li>
        </ul>
      </div>
      <div class="footer-newsletter">
        <div class="footer-title mb-4">
          Newsletter
        </div>
        <div class="footer-text mb-4">
          Many things are always happening! Get the <br> latest news, promos and events...
        </div>
        <div class="row mb-5">
          <div class="input-group mb-3">
            <input id="newsletter-email" v-model="email" type="text" placeholder="Email" class="newsletter-input"
                   required>
            <button class="btn newsletter-btn" type="button" @click.prevent="save">Sign Up</button>
          </div>
          <div class="col-md-10 offset-md-1">
            <div id="newsletter-success" v-if="success !== ''" class="alert alert-success text-center">
              {{ success }}
            </div>
            <div id="newsletter-warning" v-if="isError || error !== ''" class="alert alert-warning text-center">
              {{ error }}
            </div>
          </div>
        </div>
        <div class="newsletter-social-media d-flex font-light justify-content-start pe-5">
          <i class="fa fa-facebook icon"></i>
          <i class="fa fa-instagram icon"></i>
          <i class="fa fa-twitter icon"></i>
          <i class="fa fa-youtube-play icon"></i>
        </div>
      </div>
    </div>
    <div class="rights container-fluid d-flex justify-content-center flex-column mt-4" id="footer-rights">
      <hr class="footer-line mb-4">
      <div class="rights text-center"> ©2022 All rights reserved</div>
    </div>
  </footer>

</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      email: '',
      success: '',
      error: '',
      isError: false,
      /* eslint-disable-next-line */
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    }
  },
  methods: {
    isEmailValid: function () {
      return (this.email === "") ? "" : (this.reg.test(this.email));
    },
    async save() {
      this.isError = false;
      this.error = '';
      this.success = '';
      if (!this.isEmailValid()) {
        this.isError = true;
        this.error = 'Email is required!';
        return;
      }
      let data = {email: this.email};

      axios.post("/api/newsletter", data)
          .then((response) => {
            if (response.status === 200) {
              this.success = response.data
            } else {
              this.error = response.data
            }
          });
    }
  }
}
</script>
